export default __webpack_public_path__ + "static/media/weatherzone3.682ae793.png";